<template>
  <div>
    <v-card>

      <v-simple-table class="table-layout border-table">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="font-weight-regular" rowspan="2" style="border-bottom: thin solid rgba(0, 0, 0, 0.12)"></th>
              <th
                class="font-weight-regular"
                v-for="(type, index) in typeHeaderContactStatus"
                :key="'total-' + index"
              >
                {{type.name}}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="font-weight-bold" style="min-width: 10rem;">Số lượng</td>
              <td
                v-for="(item, index) in contactStatusTotal"
                :key="'countItemsTotal-' + index"
              >
                {{formatPrice(item.countItems)}}
              </td>
            </tr>
            <tr>
              <td class="font-weight-bold">%</td>
              <td
                v-for="(item, index) in contactStatusTotal"
                :key="'percentageTotal-' + index"
              >
                {{+item.percentage}}%
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card>

    <v-card>
      <v-simple-table class="table-layout border-table">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="font-weight-regular" rowspan="2" style="border-bottom: thin solid rgba(0, 0, 0, 0.12)"></th>
              <th
                class="font-weight-regular"
                v-for="(type, index) in typeHeaderContactStatus"
                :key="'type-' + index"
                :colspan="type.colspan"
              >
                {{type.name}}
              </th>
            </tr>
            <tr>
              <th
                class="font-weight-regular"
                style="border-top: thin solid rgba(0, 0, 0, 0.12);"
                v-for="(item, index) in contactStatusList"
                :key="'name-type-' + index"
              >
                {{item.name}}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="font-weight-bold" style="min-width: 10rem;">Số lượng</td>
              <td
                v-for="(item, index) in contactStatusList"
                :key="'countItems-' + index"
              >
                {{formatPrice(item.countItems)}}
              </td>
            </tr>
            <tr>
              <td class="font-weight-bold">%</td>
              <td
                v-for="(item, index) in contactStatusList"
                :key="'percentage-' + index"
              >
                {{+item.percentage}}%
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>

    </v-card>
  </div>
</template>
<script>
export default {
  props: {
    typeHeaderContactStatus: {
      type: Array,
      default: () => [],
    },
    contactStatusList: {
      type: Array,
      default: () => [],
    },
    contactStatusTotal: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
